import React from "react";
import * as PR from "../../prime-modules/index";

const AffiliateRowExpansion = ({
    affiliate,
    childAffiliates,
    loading = false,
    getRoleName,
    renderStatus,
    renderB2B,
    renderActions,
    onViewUsers,
    onAddUser,
}) => {
    // rows from recursive child affiliates API, or empty array if provided
    const rows = childAffiliates !== undefined ? childAffiliates : ([]);

    const getSubLabel = (row) => {
        if (row?.type === 0) return "Standard affiliate";
        if (row?.type === 1) return "Corporate affiliate";
        return getRoleName ? getRoleName(row?.role) : "-";
    };


    const nameTemplate = (row) => {
        return (
            <div className="aff-data" onClick={(e) => e.stopPropagation()}>
                <div className="aff-data__connector">
                    <span className="aff-data__node" />
                </div>
                <div className="aff-data__content">
                    <div className="aff-data__name">
                        <span>{row?.name || "-"}</span>
                    </div>
                    <div className="aff-data__sub-label">
                        <span>{getSubLabel(row)}</span>
                    </div>
                </div>
            </div>
        );
    };

    const userNameTemplate = (row) => {
        const isDisabled = !row?.isActive;
        const count = Math.max(1, row?.affiliateUsers?.length || 1);

        return (
            <div className="batch-p">
                {!isDisabled && (
                    <div className="flex align-items-center gap-2">
                        <span
                            className="click-text"
                            style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                            onClick={(e) => {
                                e.stopPropagation();
                                onViewUsers?.(row);
                            }}
                        >
                            View affiliate users ({count})
                        </span>
                        <button
                            type="button"
                            className="p-button p-button-sm add-user"
                            onClick={(e) => {
                                e.stopPropagation();
                                onAddUser?.(row);
                            }}
                        >
                            + Add User
                        </button>
                    </div>
                )}
                {isDisabled && <span className="disabled-text">Affiliate Disabled</span>}
            </div>
        );
    };

    const commissionTemplate = (row) => {
        const value = row?.type === 0
            ? row?.perOrderCommissionPercent
            : row?.voucherCreationDiscountPercent;
        return <div>{value !== undefined && value !== null ? `${value}%` : "-"}</div>;
    };

    const isLoading = loading || childAffiliates === undefined;

    if (isLoading && rows.length === 0) {
        return (
            <div className="affiliate-row-loading">
                <i className="pi pi-spin pi-spinner" />
                <span>Loading child affiliates...</span>
            </div>
        );
    }

    return (
        <div className="affiliate-row-expansion">
            <PR.DataTable
                value={rows}
                loading={loading}
                dataKey="id"
                className="affiliate-expansion-table"
                rowClassName={(row) => (!row?.isActive ? "disabled-row" : "")}
                emptyMessage={
                    <span className="text-gray-500">
                        No child affiliates found
                    </span>
                }
            >
                <PR.Column style={{ width: "3%" }} className="toggler-expander" />
                <PR.Column body={nameTemplate} style={{ width: "30%" }} className="batch-column" />
                <PR.Column body={userNameTemplate} style={{ width: "25%" }} className="affiliate-users-column" />
                <PR.Column body={commissionTemplate} style={{ width: "9%" }} className="discount-column commission-column" />
                <PR.Column body={(row) => (renderStatus ? renderStatus(row) : "-")} style={{ width: "10%" }} className="discount-column affiliate-status-column" />
                <PR.Column body={(row) => (renderB2B ? renderB2B(row) : "-")} style={{ width: "10%" }} className="discount-column b2b-api-column" />
                <PR.Column body={(row) => (renderActions ? renderActions(row) : "-")} style={{ width: "13%", minWidth: "130px" }} className="actions-column" />
            </PR.DataTable>
        </div>
    );
};

export default AffiliateRowExpansion;
